import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-workorder-progress-panel',
  templateUrl: './workorder-progress-panel.component.html',
  styleUrls: ['./workorder-progress-panel.component.scss'],
})
export class WorkorderProgressPanelComponent {
  @Input() logs: any;
  @Input() progress = '';
}
